<template>
  <BootstrapDialog
    title="选择报考范围"
    ref="dialog"
    size="lg"
    @afterClose="afterClose()"
  >
    <template v-slot:body>
      <div style="padding: 20px">
        <table
          style="width:800px;margin:0 auto;backgroundColor:#F5F5F5;border: 1px soild #696969"
        >
          <thead>
            <tr>
              <th>主考学校</th>
              <th>专业层次</th>
              <th>学科</th>
              <th>选择专业</th>
              <th>
                <button
                  type="button"
                  class="btn "
                  style="backgroundColor:#2E8B57;color:#FFFAFA"
                  @click="add()"
                >
                  <span
                    class="glyphicon glyphicon-plus"
                    aria-hidden="true"
                  ></span>
                </button>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in xzfwArr" :key="index + 'a'">
              <td>
                <BootstrapCombobox
                  :data="zkxxArr"
                  value-field="id"
                  text-field="jgmc"
                  v-model="item.zkxxId"
                  :formatOption="(zkxx) => zkxx.jgdm + '-' + zkxx.jgmc"
                ></BootstrapCombobox>
              </td>

              <td>
                <BootstrapCombobox
                  :data="zyccArr"
                  value-field="value"
                  text-field="text"
                  v-model="item.zycc"
                  :format-option="(zycc) => zycc.text"
                  @change="zyccChange(item)"
                ></BootstrapCombobox>
              </td>

              <td>
                <BootstrapCombobox
                  :data="xkArr"
                  value-field="id"
                  text-field="xkmc"
                  v-model="item.xkId"
                  :formatOption="(xk) => xk.xkdm + '-' + xk.xkmc"
                  @change="xkIdChange(item)"
                ></BootstrapCombobox>
              </td>

              <td>
                <BootstrapCombobox
                  :data="item.zyArr"
                  value-field="id"
                  text-field="zymc"
                  v-model="item.zyId"
                  :format-option="(zy) => zy.zydm + '-' + zy.zymc"
                ></BootstrapCombobox>
              </td>
              <td>
                <button
                  type="button"
                  class="btn "
                  style="backgroundColor:#FF4500;color:#FFFAFA"
                  @click="del(index)"
                >
                  <span
                    class="glyphicon glyphicon-trash"
                    aria-hidden="true"
                  ></span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template v-slot:footer>
      <button class="btn btn-primary" type="button" @click="save()">
        确认
      </button>
      <button
        style="margin-left:10px"
        class="btn btn-default"
        type="button"
        @click="close()"
      >
        关闭
      </button>
    </template>
  </BootstrapDialog>
</template>
<script>
import { zycc } from "@/plugins/enums.js";
export default {
  // props: ["modelRanges"],
  name: "",
  components: {},
  data: function() {
    return {
      //主考学校下拉
      zkxxArr: [],
      // 专业层次下拉
      zyccArr: [],
      //  学科下拉
      xkArr: [],
      // 选择专业下拉
      zyArr: [],

      // 选择范围数组
      xzfwArr: [
        {
          // 主考学校ID
          zkxxId: null,
          // 专业层次
          zycc: null,
          // 学科id
          xkId: null,
          // 专业id
          zyId: null,
          zyArr: [],
        },
      ],
      jsList: [],
      model: {
        name: "",
        ztlb: "",
      },
      zycc: null,
      xkId: null,
    };
  },

  created() {
    this.zkxx();
    this.xk();
    this.zyccArr = zycc;
  },
  mounted() {},
  methods: {
    zyccChange(item) {
      this.$http
        .post("/htgl/inf/zy/cx", {
          zycc: item.zycc,
          xkId: item.xkId,
        })
        .then((res) => {
          item.zyArr = res.data.records;
        });
    },

    xkIdChange(item) {
      this.$http
        .post("/htgl/inf/zy/cx", {
          zycc: item.zycc,
          xkId: item.xkId,
        })
        .then((res) => {
          item.zyArr = res.data.records;
        });
    },

    // 选择专业下拉
    zy() {
      this.$http.post("/htgl/inf/zy/cx", { size: 9999 }).then((res) => {});
    },

    // 学科下拉数据
    xk() {
      this.$http.post("/htgl/inf/xk/cx", { size: 9999 }).then((res) => {
        this.xkArr = res.data.records;
      });
    },
    // 主考学校下拉数据
    zkxx() {
      this.$http
        .post("/htgl/sys/jg/cx", { jglx: "ZKXX", size: 9999 })
        .then((res) => {
          this.zkxxArr = res.data.records;
        });
    },
    // 删除
    del(index) {
      this.xzfwArr.splice(index, 1);
    },
    // 点击添加
    add() {
      let obj = {
        // 主考学校ID
        zkxxId: null,
        // 专业层次
        zycc: null,
        // 学科id
        xkId: null,
        // 专业id
        zyId: null,
        zyArr: [],
      };
      this.xzfwArr.push(obj);
    },
    reset: function() {},
    async open() {
      // 打开  数据为空   只添加
      this.xzfwArr = [
        {
          // 主考学校ID
          zkxxId: null,
          // 专业层次
          zycc: null,
          // 学科id
          xkId: null,
          // 专业id
          zyId: null,
          zyArr: [],
        },
      ];
      this.$refs.dialog.open();
    },
    close: function() {
      this.$refs.dialog.close();
    },
    afterClose: function() {
      this.$validator.reset();
      this.reset();
    },

    save() {
      this.$emit("sendFwData", this.xzfwArr);
      this.close();
    },
  },
};
</script>
<style scoped>
th,
td {
  padding: 10px;
}
</style>
